
import tap from './tap';

export default {
    install(Vue){
        Vue.directive('tap', tap);
    }
}
